module.exports = __webpack_public_path__ + "media/images/dividend/ill-beach-mobile@3x-70d4d47388602b2f2625ba9012d4b5d1.png";